import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["rows", "server-side", "total-items", "current-page", "loading"]

import { EPINIO_TYPES } from '../types';
import { useStore } from 'vuex';
import { computed, ref, onMounted, onUnmounted, watchEffect } from 'vue';
import { startPolling, stopPolling } from '../utils/polling';


export default /*@__PURE__*/_defineComponent({
  __name: 'appcharts',
  props: {
    schema: {}
  },
  setup(__props: any) {

 // Keep for compatibility

const store = useStore();

const pending = ref(true);
const rows = ref<any[]>([]);

const paginationMeta = computed(() => store.getters['epinio/paginationMeta'](EPINIO_TYPES.APP_CHARTS));
const currentPage = computed(() => store.getters['epinio/currentPaginationPage'](EPINIO_TYPES.APP_CHARTS));

const paginating = ref(false);

async function goToPage(page: number) {
  const meta = paginationMeta.value;

  if (meta && (page < 1 || page > meta.totalPages)) return;
  paginating.value = true;
  try {
    await store.dispatch('epinio/goToPage', { type: EPINIO_TYPES.APP_CHARTS, page });
  } finally {
    paginating.value = false;
  }
}

watchEffect(() => {
  const all = store.getters['epinio/all'](EPINIO_TYPES.APP_CHARTS) as any[];

  // Touch meta so _MERGE polling (which deletes/re-adds all properties) re-runs this effect
  all.forEach((row: any) => { void row.meta; });
  rows.value = [...all];
});

onMounted(async () => {
  await store.dispatch(`epinio/findAll`, { type: EPINIO_TYPES.APP_CHARTS });
  pending.value = false;
  startPolling(['appcharts'], store);
});

onUnmounted(() => {
  stopPolling(['appcharts']);
});

const columns = [
  {
    field: 'meta.name',
    label: 'Name'
  },
  {
    field: 'description',
    label: 'Description'
  },
  {
    field: 'helm_chart',
    label: 'Helm Chart'
  },
  {
    field:     'meta.createdAt',
    label:     'Age',
    formatter: 'age'
  }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("trailhand-table", {
    rows: rows.value,
    columns: columns,
    searchable: true,
    "server-side": !!paginationMeta.value,
    "total-items": paginationMeta.value?.totalItems ?? rows.value.length,
    "current-page": currentPage.value,
    loading: pending.value || paginating.value,
    "key-field": "id",
    onPageChange: _cache[0] || (_cache[0] = (e) => goToPage(e.detail.page))
  }, null, 40, _hoisted_1))
}
}

})